import * as React from "react";
import ProgressiveImage from "react-progressive-image-loading";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

type ClassNames = "container" | "left" | "right";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        display: "flex",
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
        marginLeft: "10%",
        marginRight: "10%",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column-reverse !important" as "column-reverse",
            marginLeft: theme.spacing.unit * 2,
            marginRight: theme.spacing.unit * 2
        }
    },
    left: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        margin: theme.spacing.unit * 2,
        [theme.breakpoints.down("sm")]: {
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0
        }
    },
    right: {
        margin: theme.spacing.unit * 2,
        flex: 1,
        minHeight: 450,
        backgroundSize: "contain",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        [theme.breakpoints.down("sm")]: {
            margin: 0,
            backgroundSize: "cover"
        }
    }
});

interface SectionProps {
    uri: string,
    preview: string,
    reverse?: boolean
}

class Section extends React.Component<WithStyles<ClassNames> & SectionProps> {

    public renderImage = (src: string, style: React.CSSProperties) => (
        <div
            className={this.props.classes.right}
            style={{
                ...style,
                backgroundImage: `url(${src})`
            }}
        />
    );

    public render() {
        const {classes, reverse, preview, uri, children} = this.props;
        return (
            <div className={classes.container} style={{ flexDirection: reverse ? "row-reverse" : "row" }}>
                <div className={classes.left}>
                {children}
                </div>
                <ProgressiveImage
                    preview={preview}
                    src={uri}
                    render={this.renderImage}
                />
            </div>
        );
    }
}

export default withStyles(styles)<SectionProps>(Section);



// WEBPACK FOOTER //
// ./src/elements/Section.tsx